/**
 * Shared list of supported AI-response languages used by:
 *  - /onboarding (Onboarding.jsx)
 *  - /account "Onboarding data" card (Account.jsx)
 *
 * Values are ISO 639-1 codes. Labels resolve via i18n key
 * `account:onboarding.langs.<key>`.
 *
 * Extend this list to add more languages — both consumers stay in sync.
 */
export const LANGUAGE_OPTIONS = [
  { value: "es", labelKey: "account:onboarding.langs.spanish",   fallback: "Español" },
  { value: "en", labelKey: "account:onboarding.langs.english",   fallback: "Inglés" },
  { value: "pt", labelKey: "account:onboarding.langs.portuguese", fallback: "Portugués" },
  { value: "fr", labelKey: "account:onboarding.langs.french",    fallback: "Francés" },
  { value: "de", labelKey: "account:onboarding.langs.german",    fallback: "Alemán" },
  { value: "it", labelKey: "account:onboarding.langs.italian",   fallback: "Italiano" },
  { value: "ja", labelKey: "account:onboarding.langs.japanese",  fallback: "Japonés" },
  { value: "zh", labelKey: "account:onboarding.langs.chinese",   fallback: "Chino" },
  { value: "ko", labelKey: "account:onboarding.langs.korean",    fallback: "Coreano" },
  { value: "ru", labelKey: "account:onboarding.langs.russian",   fallback: "Ruso" },
  { value: "ar", labelKey: "account:onboarding.langs.arabic",    fallback: "Árabe" },
  { value: "nl", labelKey: "account:onboarding.langs.dutch",     fallback: "Neerlandés" },
];

/**
 * Backward-compatible normalizer: maps legacy English-word values
 * ("spanish", "english", …) to ISO 639-1 codes so old `context_profile.language`
 * rows still pre-select correctly in the dropdowns.
 */
export function toIsoCode(value) {
  if (!value) return "en";
  const v = String(value).trim().toLowerCase();
  const map = {
    spanish: "es", "español": "es", castellano: "es", espanol: "es",
    english: "en", "inglés": "en", ingles: "en",
    portuguese: "pt", "português": "pt",
    french: "fr", "français": "fr",
    german: "de", "deutsch": "de",
    italian: "it", "italiano": "it",
    japanese: "ja", chinese: "zh", korean: "ko",
    russian: "ru", arabic: "ar", dutch: "nl",
  };
  if (map[v]) return map[v];
  // already an ISO code?
  if (/^[a-z]{2}$/.test(v)) return v;
  return "en";
}
